export default __webpack_public_path__ + "static/media/Licenses_CommonMenu.c37e888f.svg";